/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coinvestments_Dataroom_Nodeactionsmenu4Inputs */

const en_coinvestments_dataroom_nodeactionsmenu4 = /** @type {(inputs: Coinvestments_Dataroom_Nodeactionsmenu4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Actions for {name}" |
*
* @param {Coinvestments_Dataroom_Nodeactionsmenu4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_nodeactionsmenu4 = /** @type {((inputs: Coinvestments_Dataroom_Nodeactionsmenu4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Nodeactionsmenu4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_nodeactionsmenu4(inputs)
});
export { coinvestments_dataroom_nodeactionsmenu4 as "coInvestments_dataRoom_nodeActionsMenu" }